import { uri } from '../../api-endpoint';
import {
  IProjectImageInfoAPIValidationError,
  IProjectImageInfoFromAPISuccessResponse
} from '../../type-conversion/project-image-info/from-api-repsonse';
import { ProjectImageInfoAPIRequestBodyPartial } from '../../type-conversion/project-image-info/to-api-request-body';
import { updatePartiallyTemplateFn } from '../common';

export const updateProjectImagePartially = (token: string) => (
  projectId: number,
  imageId: number
) =>
  updatePartiallyTemplateFn(
    token,
    uri.projectImageById(projectId, imageId),
    ProjectImageInfoAPIRequestBodyPartial,
    IProjectImageInfoFromAPISuccessResponse,
    IProjectImageInfoAPIValidationError
  );
